<template>
  <div class="fix">
    <audio autoplay="" loop="" id="audio" preload=""><source src="http://date.risingch.com/upload/2019-05-03/125025044a0c1d9475b60200a166c2cd.mp3"></audio>
    <div class="fix-item icon"  @click="download">
      <div class="fix-item-icon">
        <i class="iconfont icon-APP"></i>
      </div>
      <div class="fix-item-main">
        <div class="fix-item-main-qrcode">
          <div class="fix-item-main-qrcode-img">
            <div class="fix-item-main-qrcode-img-title">下载手机App</div>
            <img src="@/assets/img/download.png" alt="">
            <div class="fix-item-main-qrcode-img-title" style="padding-top:10px;font-size: 14px;line-height: 20px;color:#a3a3ac">扫一扫 下载旅享视界手机APP</div>
          </div>
        </div>
        <div class="fix-item-main-type">
          <div class="fix-item-main-type-title">选择下载方式</div>
          <div class="fix-item-main-type-list">
            <a target="_blank" href="https://itunes.apple.com/cn/app/id1384495302">
              <i class="iconfont icon-ios"></i>
              <div>iPhone</div>
            </a>
            <a target="_blank" href="http://sj.qq.com/myapp/detail.htm?apkName=com.lvxiang.risingvideo">
              <i class="iconfont icon-anzhuo"></i>
              <div>Android</div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="fix-item music" @click="togglePlayState">
      <div class="fix-item-icon">
        <i class="iconfont" :class="isPlay ? 'icon-zanting-' : 'icon-bofang-'"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'fix',
  data() {
    return {
      isPlay:true
    }
  },
  mounted(){
    this.$nextTick(() => {
        this.audioAutoPlay('audio')
    })
  },
  methods:{
    download(){
      const u = navigator.userAgent;
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      window.location.href = isAndroid ? 'http://sj.qq.com/myapp/detail.htm?apkName=com.lvxiang.risingvideo' : isIOS ? 'https://itunes.apple.com/cn/app/id1384495302' : ''
    },
    audioAutoPlay(id){  
        let audio = document.getElementById(id);
        let play = function(){  
            audio.play();  
            document.removeEventListener("touchstart",play, false);  
        };  
        audio.play(); 
        document.addEventListener("WeixinJSBridgeReady", function () {  
            play();  
        }, false);  
        document.addEventListener('YixinJSBridgeReady', function() {  
            play();  
        }, false);  
        document.addEventListener("touchstart",play, false);  
    }, 
    togglePlayState(){
      let audio = document.getElementById('audio');
      if(this.isPlay){
        audio.pause();
      }else{
        audio.play();
      }
      this.isPlay = !this.isPlay 
    }
  }
}
</script>
<style lang="scss" scoped>
.fix{
  position: fixed;
  width: 50px;
  bottom: 84px;
  right: 20px;
  background: #fff 95%;
  border-radius: 4px;
  padding-top: 5px;
  z-index: 4;
  white-space: nowrap;
  border: 1px solid #f3f4f5;
  &-item{
    padding: 0 5px 0 5px;
    margin-bottom: 5px;
    color: #ccc;
    transition: all .5s ease-in-out;
    cursor: pointer;
    &-icon{
      position: relative;
      display: inline-block;
      width: 40px;
      height: 40px;
      text-align: center;
      i{
        font-size: 35px;
        line-height: 40px;
      }
    }
    &-main{
      display: block;
      right: 65px;
      position: absolute;
      bottom: -10px;
      background: #fff;
      box-shadow: 0 0 5px rgba(0,0,0,.2);
      transform: scale(0);
      transform-origin: right center;
      opacity: 0;
      transition: .2s;
      &::after{
        content: "";
        width: 15px;
        position: absolute;
        right: -15px;
        top: 0;
        bottom: 0;
        border-left: 2px solid #000;
        border-right: 0;
        border-top: 0;
        border-bottom: 0;
        border-image: -webkit-gradient(linear,left top,left bottom,from(#f98e8d),to($base-color)) 5 5;
        border-image: linear-gradient(#f98e8d 0,$base-color 100%) 5 5;
      }
      
      &-qrcode{
        width: 260px;
        text-align: center;
        padding-top: 20px;
        &-img{
          padding: 0 30px;
          box-sizing: border-box;
          &-title{
            color: #000;
            font-size: 18px;
            line-height: 22px;
            padding-bottom: 15px;
          }
          img{
            width: 140px;
          }
        }
      }
      &-type{
        padding: 15px 0 20px 0;
        background: #f3f4f5;
        &-title{
          color: #72727b;
          padding-bottom: 15px;
          font-size: 14px;
          text-align: center;
        }
        &-list{
          @include flexMode(center,space-between,row);
          a{
            flex: 1;
            @include flexMode(center,space-around,column);
            color: #ccc;
            i{
              font-size: 30px;
            }
            div{
              font-size: 14px;
            }
            &:hover{
              color: $base-color;
            }
          }
        }
      }
    }
    &::after{
      position: absolute;
      content: "";
      display: inline-block;
      width: 0;
      height: 0;
      border-left: 8px solid $base-color;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      font-size: 0;
      top: 12px;
      left: -12px;
      transform: scale(0);
      transform-origin: left center;
      opacity: 0;
      transition: .2s;
      
    }
    &:hover{
      color: $base-color;
      transition: all .5s ease-in-out;
    }
    &.icon{
      &:hover::after{
        transform: scale(1);
        transform-origin: left center;
        opacity: 1;
        transition: .2s;
      }
      &:hover .fix-item-main{
        transform: scale(1);
        transform-origin: right center;
        opacity: 1;
        transition: .2s;
      }
      
    }
  }
}
//移动端和ipad
@media only screen and (max-width: $screen-sm-min){
  .fix-item{
    &:hover::after{
      transform: scale(0) !important;
      transform-origin: left center;
      opacity: 0 !important;
      transition: .2s;
    }
    &:hover .fix-item-main{
      transform: scale(0) !important;
      transform-origin: left center;
      opacity: 0 !important;
      transition: .2s;
    }
    &:hover{
      color: #72727b !important;
      transition: all .5s ease-in-out;
    }
  }
} 
</style>